<template>
  <div class="store-list">
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="门店名称：" prop="shopName">
          <el-input v-model="form.shopName" placeholder="请输入门店名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleInputChange">查询</el-button>
          <el-button type="primary" @click="handleAdd">添加</el-button>
          <el-button type="primary"  @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="shopName" label="门店名称" align="center"></el-table-column>
        <el-table-column prop="shopAddress" label="门店地址" align="center"></el-table-column>
        <el-table-column prop="shopPhone" label="门店电话" align="center"></el-table-column>
        <el-table-column label="门店二维码" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.shopQrCode" alt="" class="storeImg">
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="view" @click="handleView(scope.row.id)">查看店员</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
            <span class="del" @click="handleDel(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { getShopList, deleteShop } from '@/api/stores';
import Pagination from '@/components/Pagination';

export default {
  data() {
    return {
      form: {
        shopName: '',
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getShopList();
  },
  methods: {
    getShopList() {
      this.loading = true;
      getShopList({
        shopName: this.form.shopName,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getShopList();
    },
    // 添加门店
    handleAdd() {
      this.$router.push({ name: 'StoreAdd' });
    },
    // 删除
    handleDel(id) {
      deleteShop(id).then((res) => {
        if (res.success) {
          this.$message.success('删除成功');
          this.getShopList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getShopList();
    },
    // 查看
    handleView(id) {
      this.$router.push({
        name: 'StoreDetail',
        query: {
          id,
        },
      });
    },
    // 编辑
    handleEditor(id) {
      this.$router.push({
        name: 'StoreEditor',
        query: {
          id,
        },
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getShopList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getShopList();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
.view,.editor,.del
  color #1890ff
  cursor pointer
.view,.editor
  margin-right 20px
.storeImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
</style>
<style lang="stylus">
.wechatCode
  background rgba(0,0,0,0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
